import "./iconlegendmodal.scss";
import OnlinePattern from '/img/nwlmap/Online.svg?url';
import OfflinePattern from '/img/nwlmap/Offline.svg?url';
import ImpactedPattern from '/img/nwlmap/Impacted.svg?url';
import AtRiskPattern from '/img/nwlmap/Risk.svg?url';
import AnomalyPattern from '/img/nwlmap/Anomaly.svg?url';
import BlockagePattern from '/img/nwlmap/Blockage.svg?url';
import PumpPattern from '/img/nwlmap/Pump.svg?url';

const assetStatusRow = (pattern, status) => {
  return (
    <div className={'flex flex-row icon-legend-item'}>
      <img src={pattern} alt={status}/>
      <span className="mt-1">{status}</span>
    </div>
  )
}

const IconLegendModal = () => {
  return (
    <div className={'icon-legend-modal'}>
      <h3 className={'font-bold'}>Asset legend</h3>

        <div className={'flex flex-col'}>
          {assetStatusRow(OnlinePattern, 'Online or operational')}
          {assetStatusRow(OfflinePattern, 'Offline or unavailable')}
          {assetStatusRow(AtRiskPattern, 'At risk')}
          {assetStatusRow(ImpactedPattern, 'Impacted')}
          {assetStatusRow(PumpPattern, 'Pump alert')}
          {assetStatusRow(AnomalyPattern, 'Anomaly alert')}
          {assetStatusRow(BlockagePattern, 'Blockage alert')}
        </div>
    </div>
  )
}

export default IconLegendModal;